<template>
    <div class="about">
        <div class="about__inner">
            <img class="about__img" src="../images/about-img.jpg">
            <div class="about__content">
                <h1 class="about__heading heading">Про ленбукет</h1>
                <p class="about__text">Цветочный магазин "ЛЕНБУКЕТ" — это уютное и стильное место, где каждый сможет найти идеальный букет на любой случай. Мы гордимся нашим разнообразием свежих цветов и уникальных композиций, которые подойдут как для повседневных событий, так и для особых случаев.</p>

                <p class="about__text">Мы предлагаем цветы на любой вкус – от классических роз и лилий до экзотических орхидей и пионов.</p>

                <div class="about__contacts contacts">
                    <div class="contacts__wrapper">
                        <a class="contacts__link contacts__link_vk" href="https://vk.com/kudrovoflowersspb24"></a>
                        <a class="contacts__link contacts__link_wa" href="https://api.whatsapp.com/send?phone=79218077750"></a>
                        <a class="contacts__link contacts__link_tg" href="https://t.me/+79218077750"></a>
                    </div>
                    <span class="about-contacts__text">контакты</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
    .about__inner{
        display: flex;
    }
    .about__img{
        margin-right: 20px;
        border-radius: 45px;
        max-width: 590px;
        aspect-ratio: 1/1;
        object-fit: cover;
    }
    .about__content{
        display: flex;
        flex-direction: column;
    }
    .about__heading{
        margin-bottom: 100px;
    }
    .about__text{
        font-size: 20px;
        line-height: 135%;
        margin-bottom: 40px;
    }
    .about__contacts{
        display: flex;
        margin-top: auto;
        align-items: flex-end;
    }
    .contacts__link{
        height: 40px;
        width: 40px;
        margin-right: 35px;
        border-radius: 50%;
        transition: all linear .2s;
    }
    .contacts__link:hover{
        opacity: .5;
    }
    .contacts__link_vk{
        background: url(../images/icons/vk-ico.svg) no-repeat;
        background-size: cover;
    }
    .contacts__link_wa{
        background: url(../images/icons/wa-ico.svg) no-repeat;
        background-size: cover;
        border-radius: 0;
    }
    .contacts__link_tg{
        background: url(../images/icons/tg-ico.svg) no-repeat;
        background-size: cover;
        margin-right: 20px;
    }
    .about-contacts__text{
        font-size: 24px;
        font-family: 'Romul';
        color: #3A3841;
    }
    .contacts__wrapper{
        display: flex;
    }
    @media (max-width: 992px) {
        .about__img{
            max-width: 400px;
            align-self: flex-start;
        }
    }
    @media (max-width: 768px){
        .about__inner{
            flex-direction: column-reverse;
        }
        .about__content{
            margin-bottom: 15px;
        }
        .about__heading{
            margin-bottom: 15px;
        }
        .about__img{
            max-width: none;
            margin-right: 0;
            width: 100%;
            border-radius: 20px;
        }
        .about__text{
            font-size: 16px;
            margin-bottom: 20px;
        }
        .about__contacts{
            flex-direction: column-reverse;
            align-items: flex-start;
            margin-top: 30px;
        }
        .about-contacts__text{
            font-size: 20px;
            margin-bottom: 15px;
        }
        .contacts__link{
            margin-right: 10px;
            height: 36px;
            width: 36px;
        }
    }
</style>